import { Component, EventEmitter, Input } from '@angular/core';
import { isNullOrUndefined } from '@uzurv/core';
import { GenericListLinkClickHandlerData } from './generic-list-link-click-handler-data';

@Component({
  selector: 'app-generic-list-link',
  templateUrl: './generic-list-link.component.html',
  styleUrls: ['./generic-list-link.component.scss']
})
export class GenericListLinkComponent {
  @Input()
  testingId = null;

  @Input()
  linkColor = 'primary';

  @Input()
  linkTitle: string;

  @Input()
  data: any;

  @Input()
  clickHandler: EventEmitter<GenericListLinkClickHandlerData>;

  handleClick(event: MouseEvent) {
    if (!isNullOrUndefined(this.clickHandler)) {
      this.clickHandler.emit({ data: this.data, clickEvent: event });
    }
  }
}
